import { useEffect, useState } from "react";
import { api } from "@/api/client";

/** The Gallery (2026-11, fix pass A) — same authenticated blob-fetch + object-URL pattern as
 * the Floor's own attachment image (components/community/PostAttachment.jsx::SingleAttachment):
 * a bare `<img src="/api/v1/gallery/items/{id}/image">` never sends the Authorization header,
 * so a gallery.read-gated BTS image 401s for every viewer instead of rendering. Fetched once
 * per `url`, revoked on unmount/url change. Shared by both GalleryCard (masonry tile) and
 * GalleryLightbox — same image, same path, exactly one fetch per mount either way. */
export function useGalleryImage(url) {
  const [objectUrl, setObjectUrl] = useState(null);
  const [status, setStatus] = useState("loading"); // "loading" | "ready" | "error"

  useEffect(() => {
    if (!url) {
      setStatus("error");
      return;
    }
    let active = true;
    let created;
    setStatus("loading");
    setObjectUrl(null);
    api.get(url, { responseType: "blob" }).then((r) => {
      if (!active) return;
      created = window.URL.createObjectURL(r.data);
      setObjectUrl(created);
      setStatus("ready");
    }).catch(() => { if (active) setStatus("error"); });
    return () => { active = false; if (created) window.URL.revokeObjectURL(created); };
  }, [url]);

  return { objectUrl, status };
}
